export interface AppConfig {
  keycloakUrl: string;
  keycloakRealm: string;
  keycloakClientId: string;
  announcementApiUrl: string;
  /** Development builds only: a bearer token used instead of Keycloak. */
  devBearerToken: string;
  /** ZennoBrowser tariffs offered in the audience block (TARIFF_CODES); the catalogue default when unset. */
  tariffCodes: string[];
  version: string;
}

/** A comma-separated list as values; blanks are dropped. */
export const parseCodes = (value: string | undefined): string[] =>
  (value ?? '')
    .split(',')
    .map(code => code.trim())
    .filter(Boolean);

/**
 * ZennoBrowser plans as the license data names them (UA2 tariff catalogue, without the cohort suffix), plus
 * `Personal`: the service reads any caption outside its known plans as this group.
 */
export const PERSONAL_TARIFF = 'Personal';
export const DEFAULT_TARIFF_CODES = ['Start', 'Cloud', 'Pro', 'Business', PERSONAL_TARIFF];

export const config: AppConfig = {
  keycloakUrl: process.env.REACT_APP_KEYCLOAK_URL ?? '',
  keycloakRealm: process.env.REACT_APP_KEYCLOAK_REALM ?? '',
  keycloakClientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID ?? '',
  announcementApiUrl: process.env.REACT_APP_ANNOUNCEMENT_API_URL ?? '',
  devBearerToken: process.env.REACT_APP_DEV_BEARER_TOKEN ?? '',
  tariffCodes: parseCodes(process.env.TARIFF_CODES).length
    ? parseCodes(process.env.TARIFF_CODES)
    : DEFAULT_TARIFF_CODES,
  version: process.env.REACT_APP_VERSION ?? '',
};

/** Names of the variables the app cannot start without. */
export function missingConfig(c: AppConfig): string[] {
  const required: [string, string][] = [['REACT_APP_ANNOUNCEMENT_API_URL', c.announcementApiUrl]];
  if (!c.devBearerToken) {
    required.push(
      ['REACT_APP_KEYCLOAK_URL', c.keycloakUrl],
      ['REACT_APP_KEYCLOAK_REALM', c.keycloakRealm],
      ['REACT_APP_KEYCLOAK_CLIENT_ID', c.keycloakClientId],
    );
  }
  return required.filter(([, value]) => !value).map(([name]) => name);
}
